import { Link, useNavigate } from "react-router-dom";
import { ArrowRight, Building2, HardHat, Landmark, Briefcase } from "lucide-react";
import ClinqLogo from "../components/ClinqLogo";

export default function Join() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-[#04302E] text-white" style={{ fontFamily: "Manrope, ui-sans-serif, system-ui, sans-serif" }}>
      <nav className="border-b border-white/5 px-6 py-4">
        <div className="mx-auto flex max-w-6xl items-center justify-between">
          <Link to="/" className="block" data-testid="join-logo-home"><ClinqLogo /></Link>
          <Link to="/login" data-testid="join-signin-link" className="text-sm font-semibold text-white/70 hover:text-white">
            Sign in
          </Link>
        </div>
      </nav>

      <div className="mx-auto max-w-5xl px-6 py-14 sm:py-20">
        <h1
          className="text-center font-extrabold leading-[1.1] tracking-tight text-white drop-shadow-[0_2px_8px_rgba(0,0,0,0.35)]"
          style={{ fontFamily: "Manrope, sans-serif", fontSize: "clamp(1.875rem, 4.5vw, 3rem)" }}
        >
          Which one <span className="text-emerald-400">describes you</span>?
        </h1>
        <p className="mt-4 text-center text-base text-white/70">
          We&apos;ll take you down the right path — it only takes a few minutes.
        </p>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          <button
            type="button"
            data-testid="join-founder"
            onClick={() => nav("/get-started")}
            className="group rounded-2xl border border-white/10 bg-white/[0.03] p-6 text-left transition-all hover:border-emerald-400/60 hover:bg-white/[0.06]"
          >
            <div className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-emerald-400/15 ring-2 ring-emerald-400/30">
              <Building2 className="h-5 w-5 text-emerald-300" />
            </div>
            <p className="mt-4 text-lg font-bold tracking-tight">I&apos;m a Business raising capital</p>
            <p className="mt-1 text-sm text-white/60">
              Get your Capital Readiness Score and find out exactly who can fund your business.
            </p>
            <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-emerald-300 group-hover:text-emerald-200">
              Get started <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
            </span>
          </button>

          <button
            type="button"
            data-testid="join-project"
            onClick={() => nav("/get-started-project")}
            className="group rounded-2xl border border-white/10 bg-white/[0.03] p-6 text-left transition-all hover:border-sky-400/60 hover:bg-white/[0.06]"
          >
            <div className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-sky-400/15 ring-2 ring-sky-400/30">
              <HardHat className="h-5 w-5 text-sky-300" />
            </div>
            <p className="mt-4 text-lg font-bold tracking-tight">I&apos;m raising capital for a Project</p>
            <p className="mt-1 text-sm text-white/60">
              Real estate, energy, infrastructure or agri projects — get your Project Readiness Score.
            </p>
            <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-sky-300 group-hover:text-sky-200">
              Get started <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
            </span>
          </button>

          <button
            type="button"
            data-testid="join-funder"
            onClick={() => nav("/get-started-funder")}
            className="group rounded-2xl border border-white/10 bg-white/[0.03] p-6 text-left transition-all hover:border-[#F59E0B]/60 hover:bg-white/[0.06]"
          >
            <div className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-[#F59E0B]/15 ring-2 ring-[#F59E0B]/30">
              <Landmark className="h-5 w-5 text-[#F59E0B]" />
            </div>
            <p className="mt-4 text-lg font-bold tracking-tight">I&apos;m a Funder looking to invest</p>
            <p className="mt-1 text-sm text-white/60">
              Tell us your mandate and discover Funder-Ready African SMEs that match it.
            </p>
            <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-[#F59E0B] group-hover:text-amber-300">
              Get started <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
            </span>
          </button>

          <button
            type="button"
            data-testid="join-advisor"
            onClick={() => nav("/join-advisor")}
            className="group rounded-2xl border border-white/10 bg-white/[0.03] p-6 text-left transition-all hover:border-purple-400/60 hover:bg-white/[0.06]"
          >
            <div className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-purple-400/15 ring-2 ring-purple-400/30">
              <Briefcase className="h-5 w-5 text-purple-300" />
            </div>
            <p className="mt-4 text-lg font-bold tracking-tight">I&apos;m an Advisor managing clients</p>
            <p className="mt-1 text-sm text-white/60">
              Manage the capital readiness journey on behalf of your founder clients.
            </p>
            <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-purple-300 group-hover:text-purple-200">
              Get started <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}
